export default "__VITE_ASSET__DPmcbpvh__"